import { identityProvidersService } from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface DeleteIdentityProviderParams {
  companyId: string;
  id: string;
}

const useDeleteIdentityProvider = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ companyId, id }: DeleteIdentityProviderParams) => {
      return identityProvidersService.deleteIdentityProvider(companyId, id);
    },
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchIdentityProviders', companyId] });
    },
  });
};

export default useDeleteIdentityProvider;
